import React from 'react';

export default function MapPin3FillBlue({
  alt = '',
  ...props
}: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
  return <img src="/images/map-pin-3-fill-blue.png" alt={alt} width={24} height={24} {...props} />;
}
